module.exports = __webpack_public_path__ + "static/media/r_itdot_11.83f61219.png";